import {
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_FAIL,
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_SUCCESS,
  PRODUCT_DETAILS_FAIL,
  FETCH_PRODUCTS
} from "../constants/ProductType";
import swal from 'sweetalert';
import clienteAxios from '../config/axios';
import { apiCache } from '../config/cache';


export const fetchProducts = (ciudad = '',tipo='') => async (dispatch,getState) => {
    // Generar clave de cache
    const cacheKey = apiCache.generateKey('catalogos/productos', { ciudad, tipo });
    
    // Intentar obtener del cache primero
    const cachedData = apiCache.get(cacheKey);
    if (cachedData) {
      dispatch({ type: FETCH_PRODUCTS, payload: cachedData });
      return;
    }

    dispatch({
      type: PRODUCT_LIST_REQUEST,
    });
    
    const {
      userSignin: { userInfo },
    } = getState(); 
    let id= "0";

    if (!userInfo){
       id ="0"
      
    } else{
      id= userInfo.id_cliente
    }

    try {
      let target = ''
      if (tipo != ''){ 
        target = `/portipo/${tipo}`;
      }
      
      const { data } = await clienteAxios.get(`catalogos/productos/`+ ciudad +  target);
      
      // Guardar en cache (3 minutos para datos dinámicos)
      apiCache.set(cacheKey, data.data, 3 * 60 * 1000);
      
      dispatch({ type: FETCH_PRODUCTS, payload: data.data });
      localStorage.setItem("idCalificador", JSON.stringify(data.data));
      
    } catch (error) {
      dispatch({ type: PRODUCT_LIST_FAIL, payload: error.message }); 
        swal({
          title: "¡Ups !",
          text: error.message,
          icon: "error",
          dangerMode: true,
        })
        .then(willDelete => {
          if (willDelete) {
           window.location.replace('/');
           
          }
        });
    }
  };


  export const empyFetchProducts = () => async (dispatch,getState) => {
    dispatch({
      type: PRODUCT_LIST_REQUEST,
    });
    const {
      userSignin: { userInfo },
    } = getState(); 
    let id= "0";

   
    
    try {
   
      dispatch({ type: FETCH_PRODUCTS, payload: [] });
      localStorage.setItem("idCalificador", JSON.stringify([]));
      
    } catch (error) {
     
    }
  };
  
export const fetchProductsById = (id) => async (dispatch,getState) => {
    dispatch({
      type: PRODUCT_LIST_REQUEST,
    });
    const {
      userSignin: { userInfo },
    } = getState(); 
    // let id= "0";

    // if (!userInfo){
    //    id ="0"
      
    // } else{
    //   id= userInfo.id_cliente
    // }
    try {

      const { data } = await clienteAxios.get(`catalogos/productos/detalles/` + id);
      dispatch({ type: FETCH_PRODUCTS, payload: data.data });
      localStorage.setItem("idCalificador", JSON.stringify(data.data));
      
    } catch (error) {
      dispatch({ type: PRODUCT_LIST_FAIL, payload: error.message }); 
        swal({
          title: "¡Ups !",
          text: error.message,
          icon: "error",
          dangerMode: true,
        })
        .then(willDelete => {
          if (willDelete) {
           window.location.replace('/');
           
          }
        });
    }
};
  


export const detailsProduct = (productId) => async (dispatch) => {

    try {
      dispatch({ type: PRODUCT_DETAILS_REQUEST, payload: productId });
      const data = await clienteAxios.get(`/encounters/listSelectById/${productId}`);
      //console.log("details", data);
      dispatch({ type: PRODUCT_DETAILS_SUCCESS, payload: data.data });
    } catch (error) {
      dispatch({ type: PRODUCT_DETAILS_FAIL, payload: error.message });
      swal({
        title: "¡Ups !",
        text: error.message,
        icon: "error",
        dangerMode: true,
      })
      .then(willDelete => {
        if (willDelete) {
         window.location.replace('/');
         
        }
      });
    }
   
  };